import { Component, ElementRef, Input, Optional, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormValidationDirective } from '@Shared/Directives/proprietary/form-validation.directive';

@Component({
    standalone: false,
    selector: 'ep-field-section',
    template: `
    <div class="fieldSectionName">{{ displayName }}</div>
    <div *ngIf="title && !hidden && hasChildFields" class="fieldSectionHeader">
      {{ title }}
    </div>
    <div class="fieldSectionContent" #fieldSectionContent>
      <ng-content *ngIf="!hidden"></ng-content>
    </div>
    <div *ngIf="title && !hidden" class="fieldSectionFooter"></div>
  `
})
export class FieldSectionComponent {
    @Input()
    title: string = null;

    @Input()
    form: UntypedFormGroup;

    @Input()
    name: string = null;

    @ViewChild('fieldSectionContent', { static: false })
    private fieldSectionContent: ElementRef;

    get displayName(): string {
        if (this.name) {
            return 'Section ' + this.name.slice(5).toUpperCase(); //strip epfs_ prefix
        }
        return 'Section?';
    }

    constructor(@Optional() private formValidationDirective: FormValidationDirective, public element: ElementRef) { }

    get hidden() {
        if (this.formValidationDirective) {
            return this.formValidationDirective.hidden(this.name);
        }
        return false;
    }

    get hasChildFields() {
        if (this.fieldSectionContent && this.fieldSectionContent.nativeElement?.children) {
            let childFields = this.getAllChildFields(this.fieldSectionContent.nativeElement);

            for (var i in childFields) {
                if (childFields[i].children?.length > 0) {
                    return true;
                }
            }
        }

        return false;
    }

    private getAllChildFields(htmlElement: any) {
        if (htmlElement.children.length === 0) return;

        let allChildElements: any = [];

        for (let i = 0; i < htmlElement.children.length; i++) {
            if (htmlElement.children[i].localName == 'ep-field' || htmlElement.children[i].localName == 'ep-field-inner') {
                allChildElements.push(htmlElement.children[i]);
            } else {
                let children = this.getAllChildFields(htmlElement.children[i]);
                if (children) {
                    allChildElements.push(...children);
                }
            }
        }

        return allChildElements;
    }
}
